/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
      mediaItem: '[data-media-id]',
      modalOpeners: '[data-modal-opener-id]',
      zoomContainer: '[data-zoom-container]',
      zoomImages: '[data-pswp-image]',
      btnXr: '[data-shopify-xr]',
      withThumbs: '[data-with-thumbs]',
    };
    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider).querySelector(
          '[data-selected]'
        )?.dataset.index
      ) || 0;

    this.settings = {
      sliderElement: this.querySelector(this.selectors.slider),
      sliderInstance: null,
      options: {
        initialSlide: this.selectedMediaIndex,
        navigation: {
          prevEl: this.querySelector('.swiper-button--prev'),
          nextEl: this.querySelector('.swiper-button--next')
        },
        spaceBetween: 2,
        watchOverflow: true,
        centeredSlides: true,
        autoHeight: this.dataset.autoHeight === 'true',
        thumbs: {
  swiper: {
    el: '.swiper-thumbs',
    direction: 'vertical',
    slidesPerView: 'auto',
    freeMode: false,
    watchOverflow: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    mousewheel: true,

    breakpoints: {
      576: {
        spaceBetween: 6
      },
      990: {
        spaceBetween: 10
      }
    }
  }
},
        on: {
          afterInit: swiper => {
            // if firstSlide has video, play it
            const firstSlide = swiper.slides[0];
            const firstSlideVideo =
              swiper.slides[0].querySelector('video');
            if (firstSlideVideo) {
              firstSlideVideo.play();
            }

            // if firstSlide has youtube, play it
            const firstSlideYoutube =
              firstSlide.querySelector('.js-youtube');
            if (firstSlideYoutube) {
              this.playYoutubeVideo(firstSlideYoutube);
            }

            // if firstSlide has vimeo, play it
            const firstSlideVimeo =
              firstSlide.querySelector('.js-vimeo');
            if (firstSlideVimeo) {
              this.playVimeoVideo(firstSlideVimeo);
            }
          },
          slideChangeTransitionEnd: swiper => {
            this.setActiveModalOpener(swiper);
          },
          transitionStart: swiper => {
            const videos = swiper.el.querySelectorAll('video');
            Array.from(videos).forEach(video => {
              video.pause();
            });
          },
          transitionEnd: swiper => {
            let slideIndex = swiper.activeIndex;
            const swiperCardWidth = swiper.slides[0].offsetWidth;
            slideIndex = Math.abs(
              Math.floor(swiper.translate / [swiperCardWidth])
            );
            if (slideIndex !== 0) {
              slideIndex = slideIndex - 1;
            }
            const activeSlide = Array.from(swiper.slides).find(
              sliderSlide =>
                sliderSlide.classList.contains('swiper-slide-active')
            );

            // play or pause videos in active and next slides
            const activeSlideVideo =
              activeSlide.querySelector('video');
            const nextSlideVideo =
              activeSlide.nextElementSibling?.querySelector('video');

            const playVideo = video => {
              if (video && video.paused) {
                video.play();
              } else if (video) {
                video.pause();
              }
            };

            playVideo(activeSlideVideo);
            playVideo(nextSlideVideo);

            const activeSlideYoutube =
              activeSlide.querySelector('.js-youtube');
            if (activeSlideYoutube) {
              this.playYoutubeVideo(activeSlideYoutube);
            }

            const activeSlideVimeo =
              activeSlide.querySelector('.js-vimeo');
            if (activeSlideVimeo) {
              this.playVimeoVideo(activeSlideVimeo);
            }
          }
        }
      }
    };
  }

  playYoutubeVideo(element) {
    element.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
  }

  playVimeoVideo(element) {
    element.contentWindow.postMessage('{"method":"play"}', '*');
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const [zoomContainerWidth, zoomContainerHeight, closeIcon] = [
      this.offsetWidth,
      this.offsetHeight,
      this.querySelector('[data-close-icon')
    ];

    function isPhone() {
      return window.innerWidth < 750;
    }

    const photoSwipeLightboxInstance = new PhotoSwipeLightbox({
      gallery: this.selectors.zoomImages,
      appendToEl: document.body,

initialZoomLevel: (zoomLevelObject) => {
  return zoomLevelObject.fit;
},
secondaryZoomLevel: (zoomLevelObject) => {
  return Math.min(zoomLevelObject.fit * 1.45, 1.35);
},
maxZoomLevel: 2.2,
showHideAnimationType: 'zoom',
bgOpacity: 0.98,
wheelToZoom: true,
clickToCloseNonZoomable: false,
getViewportSizeFn: function () {
  return {
    x: window.innerWidth,
    y: window.innerHeight
  };
},
      pswpModule: PhotoSwipe
    });
    photoSwipeLightboxInstance.addFilter(
      'uiElement',
      (element, data) => {
        if (data.name === 'close') {
          element.innerHTML = closeIcon.innerHTML;
        }
        return element;
      }
    );

    photoSwipeLightboxInstance.init();
this.enableKairosImageClickZoom();

    if (!this.settings.sliderElement) return;

    this.settings.sliderInstance = new Swiper(
      this.settings.sliderElement,
      this.settings.options
    );
    this.initKairosFloatingThumbNav();
  }
initKairosFloatingThumbNav() {
  const mediaSlider = this.querySelector('.product__media-slider');
  const thumbsEl = this.querySelector('.swiper-thumbs');
  const thumbsSwiper = this.settings.sliderInstance?.thumbs?.swiper;

  if (!mediaSlider || !thumbsEl || !thumbsSwiper) return;
  if (mediaSlider.querySelector('.kairos-floating-thumb-up')) return;

  const upBtn = document.createElement('button');
  upBtn.type = 'button';
  upBtn.className = 'kairos-floating-thumb-nav kairos-floating-thumb-up';
  upBtn.setAttribute('aria-label', 'Önceki görseller');
  upBtn.innerHTML = `
  <svg class="kairos-thumb-icon kairos-thumb-icon--up" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
    <path d="M9.5 18.5L16 12L22.5 18.5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.5 21.5L16 17L20.5 21.5" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" opacity="0.45"/>
  </svg>
`;

  const downBtn = document.createElement('button');
  downBtn.type = 'button';
  downBtn.className = 'kairos-floating-thumb-nav kairos-floating-thumb-down';
  downBtn.setAttribute('aria-label', 'Sonraki görseller');
  downBtn.innerHTML = `
  <svg class="kairos-thumb-icon kairos-thumb-icon--down" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
    <path d="M9.5 13.5L16 20L22.5 13.5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.5 10.5L16 15L20.5 10.5" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" opacity="0.45"/>
  </svg>
`;

  mediaSlider.appendChild(upBtn);
  mediaSlider.appendChild(downBtn);

  const positionButtons = () => {
    const sliderRect = mediaSlider.getBoundingClientRect();
    const thumbsRect = thumbsEl.getBoundingClientRect();

    const left = thumbsRect.left - sliderRect.left + thumbsRect.width / 2;
const upTop = thumbsRect.top - sliderRect.top - 18;
const downTop = thumbsRect.bottom - sliderRect.top + 6;
    upBtn.style.left = `${left}px`;
    upBtn.style.top = `${upTop}px`;

    downBtn.style.left = `${left}px`;
    downBtn.style.top = `${downTop}px`;
  };

  const updateState = () => {
    upBtn.classList.toggle('is-disabled', thumbsSwiper.isBeginning);
    downBtn.classList.toggle('is-disabled', thumbsSwiper.isEnd);
    positionButtons();
  };

  upBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    thumbsSwiper.slidePrev(250);
    setTimeout(updateState, 260);
  });

  downBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    thumbsSwiper.slideNext(250);
    setTimeout(updateState, 260);
  });

  thumbsSwiper.on('slideChange', updateState);
  thumbsSwiper.on('transitionEnd', updateState);

  window.addEventListener('resize', positionButtons);

  requestAnimationFrame(updateState);
  setTimeout(updateState, 400);
}
enableKairosImageClickZoom() {
  const slider = this.querySelector(this.selectors.slider);

  if (!slider) return;
  if (slider.dataset.kairosClickZoom === 'true') return;

  slider.dataset.kairosClickZoom = 'true';

  slider.addEventListener('click', (event) => {
    /* Mobilde yanlışlıkla zoom açılmasın; mobilde mevcut fullscreen ikon kalsın */
    if (window.innerWidth < 750) return;

    if (
      event.target.closest('.swiper-thumbs') ||
      event.target.closest('.kairos-floating-thumb-nav') ||
      event.target.closest('button') ||
      event.target.closest('a')
    ) {
      return;
    }

    const activeSlide = slider.querySelector('.swiper-slide-active');
    const activeMediaId = activeSlide?.dataset?.mediaId;

    const activeOpener =
      activeMediaId
        ? this.querySelector(`${this.selectors.modalOpeners} [data-media-id="${activeMediaId}"]`)?.closest(this.selectors.modalOpeners)
        : null;

    const fallbackOpener = this.querySelector(`${this.selectors.modalOpeners}.is-active`);
    const opener = activeOpener || fallbackOpener;

    const zoomTarget = opener?.querySelector(this.selectors.zoomImages) || opener;

    if (zoomTarget && typeof zoomTarget.click === 'function') {
      event.preventDefault();
      zoomTarget.click();
    }
  });
}
  setActiveMedia(id) {
    const mediaFound = Array.from(
      this.querySelectorAll(this.selectors.mediaItem)
    ).find(media => Number(media.dataset.mediaId) === id);
    if (!mediaFound) return;
    this.settings.sliderInstance.slideTo(
      Number(mediaFound.dataset.index)
    );


    // const thumbs = this.settings.sliderInstance.thumbs.swiper;
    // thumbs.slideTo(Number(mediaFound.dataset.index));

  }

  setActiveModalOpener(swiper) {
    const activeSlide = swiper.slides.filter(sliderSlide =>
      sliderSlide.classList.contains('swiper-slide-active')
    )[0];
    if (!activeSlide) return;
    const activeMediaId = activeSlide.dataset.mediaId;
    this.querySelector(
      `${this.selectors.modalOpeners}.is-active`
    )?.classList.remove('is-active');
    this.querySelector(
      `${this.selectors.modalOpeners} [data-media-id="${activeMediaId}"]`
    )?.parentElement.classList.add('is-active');

    const isModel = activeSlide.dataset.mediaType === 'model';

    if (!isModel) return;

    const btnXr = this.querySelector(this.selectors.btnXr);
    btnXr.dataset.shopifyModel3dId = activeMediaId;
  }
}

customElements.define('product-media', ProductMedia);
